import { isLiveMallClub } from '@/constants/systemType'
import classnames from 'classnames/bind'
import { useField, useFormikContext } from 'formik'
import { isEmpty } from 'lodash-es'
import PropTypes from 'prop-types'

// Components
import Input from '@/components/common/livemallclub/Input/index.tsx'

// Variables / Functions
import styles from './style.module.scss'

const cx = classnames.bind(styles)

export const propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  isOnlyNumber: PropTypes.bool,
  isAllowBlank: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
}

export const defaultProps = {
  isOnlyNumber: false,
  isAllowBlank: true,
  onChange: () => {},
  onBlur: () => {},
}

function InputField(props) {
  const { className, name, isOnlyNumber, isAllowBlank, onChange: onChangeProps, onBlur: onBlurProps, placeholder, disabled, ...restProps } = props
  const [field, meta] = useField(props)
  const { setFieldValue, handleBlur } = useFormikContext()

  const hasError = meta.touched && !isEmpty(meta.error)

  const onChange = (event) => {
    const value = event.target.value

    const numberRex = /^[0-9]*$/g
    const isNumber = value.match(numberRex)

    // 限制 input 只能輸入數字
    if (isOnlyNumber && !isNumber) return

    // 限制不能輸入空白
    if (!isAllowBlank) {
      if (value?.indexOf(' ') !== -1) return
    }

    setFieldValue(field.name, value)
    onChangeProps(value)
  }

  const onBlur = (event) => {
    onBlurProps(event)
    handleBlur(event)
  }

  return (
    <div
      className={cx(
        'input-field-wrapper',
        {
          'common-component-input': isLiveMallClub,
        },
        className,
      )}
    >
      <Input
        className={cx('input-field-wrapper-input')}
        onChange={onChange}
        onBlur={onBlur}
        value={field.value}
        name={name}
        hasError={hasError}
        placeholder={placeholder}
        disabled={disabled}
        {...restProps}
      />
    </div>
  )
}

InputField.propTypes = propTypes
InputField.defaultProps = defaultProps

export default InputField
